import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'students';

// 获取学员列表
export function index(data) {
  return get({
    url,
    data,
  });
}

export function getStudentRanks(data) {
  return get({
    url: `${url}/ranks`,
    data,
  });
}

export function getStudentPageRecords(data) {
  return get({
    url: `${url}/page-records`,
    data,
  });
}

export function getStudentIdByPhone({ phone, exclude_student_id }) {
  return get({
    url: `${url}/phones/${phone}`,
    data: { exclude_student_id },
  });
}

export function getStudentIdByCardNumber({ card_number, exclude_student_id }) {
  return get({
    url: `${url}/card-numbers/${card_number}`,
    data: { exclude_student_id },
  });
}

export function getCardNumberByStudentId(id) {
  return get({
    url: `${url}/${id}/card-numbers`,
  });
}

// 判断学员是否为新生的精细逻辑
export function checkIsNew(id) {
  return get({
    url: `${url}/${id}/check-is-new`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

// 注册学员
export function store(data) {
  return post({
    url,
    data,
  });
}

// 还原已注销的学员
export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

// 设为新老师
export function setTeacher(id) {
  return post({
    url: `${url}/${id}/teachers`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

// 绑定旧老师
export function bindTeacher(id, data) {
  return patch({
    url: `${url}/${id}/teachers`,
    data,
  });
}

// 注销学员
export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

// 设置学员归档
export function setArchive(id, data) {
  return post({
    url: `${url}/${id}/archives`,
    data,
  });
}

// 取消学员归档
export function cancelArchive(id, data) {
  return del({
    url: `${url}/${id}/archives`,
    data,
  });
}

// 取消老师绑定
export function delTeacher(id, data) {
  return del({
    url: `${url}/${id}/teachers`,
    data,
  });
}
